import React from "react";
import styled from "styled-components";

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  margin-bottom: ${props => props.theme.space[3]}px;
`;

export default ({ beneficios }) => {
  return (
    <List>
      {beneficios.map((beneficio, i) => (
        <Item key={i}>{beneficio}</Item>
      ))}
    </List>
  );
};
